export const TICKET_TYPE = {
  PICKUP: 'PICKUP',
  DELIVERY: 'DELIVERY',
  EXPRESS: 'EXPRESS',
};



// WEBPACK FOOTER //
// ./src/const/ticket_type.js